const sideNav = {
  defaultHeading: "Á þessari síðu",
};

export default sideNav;
